import React from "react";
import { TranslatedSeekingBlockProps } from "interface/seekingBlock.interface";
import { ExternalLinkProps } from "interface/linkProps.interface";
import { getLanguage } from "lib/language";
import { BUTTON_CLASSNAME } from "constants/language";
import "styles/funderLearnMoreBlock.scss";

const funderLearnMoreBlock = (props: TranslatedSeekingBlockProps): JSX.Element => {
  const { title, description, btns } = props;
  const language = getLanguage();

  return (
    <div className="funder-learn-more-wrapper d-flex w-100">
      <section className="d-flex flex-column">
        <div className="learn-more-title font-weight-bold">{title}</div>
        <div className="learn-more-description">{description}</div>
        <div className="learn-more-block-btn pt-4">
          {btns.map(
            (
              { href, text, btnType }: ExternalLinkProps,
              index: number
            ): JSX.Element => {
              return (
                <a
                  key={`btn_${index}`}
                  className={
                    btnType &&
                    `${BUTTON_CLASSNAME[btnType][language]} btn font-weight-bold py-3`
                  }
                  href={`${href}${language}`}
                >
                  {text}
                </a>
              );
            }
          )}
        </div>
      </section>
    </div>
  );
};

export default funderLearnMoreBlock;